import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filters-sort",
  "use": "icon-filters-sort-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-filters-sort\"><path d=\"M14.215 13.219h-9v-.844h9v.844Zm3-3.938h-15v-.844h15v.844Zm-2.469-3.656H3.496v-.844h11.25v.844Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol